import React from 'react'
import { currencyFormat, formateDate } from 'utils'

function Line({ label, value }) {
  if (!value) return null
  return (
    <div className='tw-flex tw-justify-between tw-text-sm tw-py-1'>
      <span className='tw-text-gray-500'>{label}</span>
      <span className='tw-text-gray-800 tw-text-right'>{value}</span>
    </div>
  )
}

function OrderDetail({ order }) {
  if (!order) return null
  const address = order.deliveryAddress
  const addressText = address
    ? [address.street, address.area, address.city].filter(Boolean).join(', ')
    : ''

  return (
    <div className='tw-flex tw-flex-col tw-gap-4'>
      <div>
        <p className='tw-font-mono tw-font-bold tw-text-navyBlue'>
          {order.orderNumber}
        </p>
        <p className='tw-text-xs tw-text-gray-400'>
          {formateDate(order.createdAt)}
        </p>
      </div>

      <div className='tw-border tw-border-[#E7DFD9] tw-rounded-[8px] tw-p-3'>
        <h4 className='tw-font-semibold tw-mb-1'>Customer</h4>
        <Line label='Name' value={order.customerInfo?.name} />
        <Line label='Phone' value={order.customerInfo?.phone} />
        <Line label='Email' value={order.customerInfo?.email} />
        <Line label='Address' value={addressText} />
        <Line label='Notes' value={order.deliveryAddress?.notes || order.notes} />
      </div>

      <div className='tw-border tw-border-[#E7DFD9] tw-rounded-[8px] tw-p-3'>
        <h4 className='tw-font-semibold tw-mb-2'>Items</h4>
        <div className='tw-flex tw-flex-col tw-gap-2'>
          {(order.items || []).map((item, index) => (
            <div
              key={index}
              className='tw-flex tw-items-center tw-justify-between tw-text-sm'
            >
              <span className='tw-text-gray-700'>
                {item.quantity} × {item.name}
              </span>
              <span className='tw-text-gray-800'>
                {currencyFormat((item.price || 0) * (item.quantity || 1))}
              </span>
            </div>
          ))}
        </div>
      </div>

      <div className='tw-border tw-border-[#E7DFD9] tw-rounded-[8px] tw-p-3'>
        <Line label='Subtotal' value={currencyFormat(order.subtotal || 0)} />
        {order.discountAmount ? (
          <Line
            label={`Discount${order.couponCode ? ` (${order.couponCode})` : ''}`}
            value={`- ${currencyFormat(order.discountAmount)}`}
          />
        ) : null}
        {order.taxAmount ? (
          <Line label='Tax' value={currencyFormat(order.taxAmount)} />
        ) : null}
        {order.deliveryFee ? (
          <Line label='Delivery fee' value={currencyFormat(order.deliveryFee)} />
        ) : null}
        <div className='tw-flex tw-justify-between tw-font-bold tw-pt-2 tw-mt-1 tw-border-t tw-border-[#E7DFD9]'>
          <span>Total</span>
          <span>{currencyFormat(order.totalAmount || 0)}</span>
        </div>
        <Line label='Payment' value={order.paymentMethod} />
        <Line label='Status' value={order.status} />
      </div>
    </div>
  )
}

export default OrderDetail
